import React from 'react';
import {
  Badge,
  HStack,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

interface MatchScoreHeaderProps {
  teamA: string;
  teamB?: string;
  scoreA?: number | null;
  scoreB?: number | null;
  teamLogos?: Record<string, string>;
  logoSize?: string;
  badgePx?: number;
}

/** Cabecera de partido: apila equipos y marcador en móvil. */
export const MatchScoreHeader: React.FC<MatchScoreHeaderProps> = ({
  teamA,
  teamB = '',
  scoreA,
  scoreB,
  teamLogos,
  logoSize = '32px',
  badgePx = 3,
}) => {
  const scoreBg = useColorModeValue('pitch.600', 'pitch.500');
  const scoreLabel = `${scoreA ?? '–'} : ${scoreB ?? '–'}`;

  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      spacing={{ base: 3, sm: 2 }}
      align={{ base: 'stretch', sm: 'center' }}
      justify="space-between"
    >
      <HStack flex={1} minW={0}>
        <Image
          src={teamLogos?.[teamA] || '/images/mundial_2026.png'}
          alt=""
          boxSize={logoSize}
          flexShrink={0}
          objectFit="contain"
        />
        <Text fontWeight="bold" fontSize="sm" noOfLines={2}>
          {teamA}
        </Text>
      </HStack>

      <Badge
        bg={scoreBg}
        color="white"
        fontSize="md"
        px={badgePx}
        alignSelf={{ base: 'center', sm: 'auto' }}
        flexShrink={0}
      >
        {scoreLabel}
      </Badge>

      <HStack flex={1} justify={{ base: 'flex-start', sm: 'flex-end' }} minW={0}>
        <Text fontWeight="bold" fontSize="sm" noOfLines={2} textAlign={{ base: 'left', sm: 'right' }}>
          {teamB}
        </Text>
        <Image
          src={teamLogos?.[teamB] || '/images/mundial_2026.png'}
          alt=""
          boxSize={logoSize}
          flexShrink={0}
          objectFit="contain"
        />
      </HStack>
    </Stack>
  );
};
